document.addEventListener('alpine:init', () => {
  Alpine.data('verticalTabs', () => ({
    activeTab: null,
    tabs: [],
    breakpoints: [],

    init() {
      if (!document.body.classList.contains('wp-admin')) {
        this.$nextTick(() => {
          const headings = [...this.$root.querySelectorAll('[data-inner-blocks] > :where(h1, h2, h3, h4, h5, h6)')];

          for (const h of headings) {
            this.tabs.push({ label: h.innerText.trim(), el: h });
          }

          document.body.style.overflowX = 'clip';

          window.addEventListener('resize', () => this.onResize());
          window.addEventListener('load', () => this.onResize());
          window.addEventListener('scroll', () => this.onScroll());

          this.onResize();
          this.onScroll();

          setTimeout(() => this.onResize(), 500);
        });
      }
    },

    scrollToTab(tab) {
      this.activeTab = tab.el;
      tab.el.scrollIntoView({ behavior: 'smooth' });
    },

    onResize() {
      this.breakpoints = this.tabs.map(
        ({ el }) => el.getBoundingClientRect().top + window.scrollY - window.innerHeight / 2
      );
    },

    onScroll() {
      this.activeTab = this.tabs[0]?.el ?? null;

      for (const [i, b] of this.breakpoints.entries()) {
        if (window.scrollY > b) {
          this.activeTab = this.tabs[i].el;
        }
      }
    },
  }));
});